import styled from "styled-components";
import { COLORS } from "@/react/theme/constants";

export const SpaceBetweenContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DropdownController = styled.div`
  background: ${COLORS.secondary};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  border-radius: 4px;
`;
